export const convertOptArr = (data, valueKey = 'id', labelKey = 'name') => {
  return data?.map((v) => ({
    ...v,
    value: String(v?.[valueKey]),
    label: v?.[labelKey]
  }))
}
